<template>
  <div class="horizontal-scroll-wrapper">
    <img v-show="prevArrow" @mousedown="scrollLeft" :src="images.prevArrow" class="arrow prev" alt />
    <div
      @scroll="scroll"
      @wheel="wheel"
      @mouseenter="active = true"
      @mouseleave="active = false"
      class="horizontal-scroll padding-left-x2 padding-right-x2"
    >
      <slot></slot>
    </div>
    <img v-show="nextArrow" @mousedown="scrollRight" :src="images.nextArrow" class="arrow next" alt />
  </div>
</template>
<script>
import images from "../../core/images";
const deg = 30;
export default {
  inheritAttrs: false,
  name: "horizontal-scroll",
  data() {
    return {
      active: false,
      maxScrollLeft: 0,
      prevArrow: false,
      nextArrow: false,
      updateTask: null,
      mousedownTask: null
    };
  },
  computed: {
    images: () => images
  },
  mounted() {
    this.updateTask = setInterval(() => {
      this.calcMaxScroll();
      this.scroll();
    }, 1500);
  },
  beforeDestroy() {
    clearInterval(this.updateTask);
  },
  methods: {
    getScrollTarget(el) {
      return el.getElementsByClassName("horizontal-scroll")[0];
    },
    calcMaxScroll(el) {
      if (!el) {
        el = this.getScrollTarget(this.$el);
      }
      this.maxScrollLeft = el.scrollWidth - el.clientWidth;
    },
    scrollLeft() {
      let el = this.getScrollTarget(this.$el);
      if (this.maxScrollLeft > 0) {
        if (el.scrollLeft > 0) {
          el.scrollLeft = Math.max(0, el.scrollLeft - deg);
        }
      }
    },
    scrollRight() {
      let el = this.getScrollTarget(this.$el);
      if (this.maxScrollLeft > 0) {
        if (el.scrollLeft < this.maxScrollLeft) {
          el.scrollLeft = Math.min(this.maxScrollLeft, el.scrollLeft + deg);
        }
      }
    },
    scroll() {
      let el = this.getScrollTarget(this.$el);
      if (el.clientWidth === 0 || el.clientWidth === el.scrollWidth) {
        this.prevArrow = false;
        this.nextArrow = false;
        return;
      }
      let scrollLeft = Math.round(el.scrollLeft, 0);
      let maxScrollLeft = Math.round(this.maxScrollLeft, 0);
      if (scrollLeft === 0) {
        this.prevArrow = false;
        this.nextArrow = true;
      } else if (scrollLeft === maxScrollLeft) {
        this.prevArrow = true;
        this.nextArrow = false;
      } else if (maxScrollLeft === 0) {
        this.prevArrow = false;
        this.nextArrow = false;
      } else {
        this.prevArrow = true;
        this.nextArrow = true;
      }
    },
    wheel(e) {
      if (this.active) {
        let el = this.getScrollTarget(this.$el);
        if (this.maxScrollLeft > 0) {
          if (el.scrollLeft > 0 && (e.deltaY < 0 || e.wheelDeltaY > 0)) {
            el.scrollLeft = Math.max(0, el.scrollLeft - deg);
          } else if (
            el.scrollLeft < this.maxScrollLeft &&
            (e.deltaY > 0 || e.wheelDeltaY < 0)
          ) {
            el.scrollLeft = Math.min(this.maxScrollLeft, el.scrollLeft + deg);
          }
        }
        e.preventDefault();
        return false;
      }
    }
  }
};
</script>
<style lang="scss">
.horizontal-scroll-wrapper {
  overflow: hidden;
  position: relative;
  .horizontal-scroll {
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    scroll-behavior: unset;
    &::-webkit-scrollbar {
      width: 1px;
      height: 1px;
    }
    &::-webkit-scrollbar-button {
      width: 1px;
      height: 1px;
    }
  }
  .arrow {
    top: 0;
    bottom: 0;
    z-index: 1;
    margin: auto;
    width: 3rem;
    height: 3rem;
    opacity: 0.5;
    cursor: pointer;
    position: absolute;
    transition: opacity 0.3s;
    &:hover {
      opacity: 1;
    }
    &.prev {
      left: -0.5rem;
    }
    &.next {
      right: -0.5rem;
    }
  }
}
</style>